





























import { Vue, Component } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { ENTRY_UPDATE, EDITOR_SET_ICON } from '@/store/editor/constants'

import IconSelectorPanel from './IconSelectorPanel.vue'

@Component({ name: 'icon-selector', components: {IconSelectorPanel } })
export default class IconSelector extends Vue {
    editing: boolean = false

    /**
     * Commit the change to the entry
     */
    @Action(ENTRY_UPDATE)
    updateEntry!: () => Promise<void>

    @Mutation(EDITOR_SET_ICON)
    setEntryIcon!: (icon: string) => void

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    beginEditing(event: Event): void {
        this.editing = true
        event.preventDefault()
        event.stopPropagation()
        this.$nextTick(() => {
            window.addEventListener('click', this.stopEditing)
        })
    }

    stopEditing(): void {
        this.editing = false
        window.removeEventListener('click', this.stopEditing)
    }

    async setIcon(value: string): Promise<void> {
        this.setEntryIcon(value)
        if (this.entry.existing) {
            await this.updateEntry()
        }
        this.stopEditing()
    }

    get isEmoji(): boolean {
        return this.entry.icon.startsWith('emoji:')
    }

    get icon(): string {
        if (this.isEmoji) {
            return this.entry.icon.replace(/emoji:/, '')
        }
        return this.entry.icon.replace(/icon:/, '')
    }
}
